import { render, staticRenderFns } from "./pendOrderDetail.vue?vue&type=template&id=7b87c8cc&scoped=true&"
import script from "./pendOrderDetail.vue?vue&type=script&lang=js&"
export * from "./pendOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./pendOrderDetail.vue?vue&type=style&index=0&id=7b87c8cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b87c8cc",
  null
  
)

export default component.exports